import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getRegion } from "src/utils";
import { getStates } from "src/utils/states";
import AreaInputs from "./AreaInputs";

function mapStateToProps({ account }: ApplicationStore) {
    const region = getRegion(account);

    return {
        allStates: getStates(region),
        isCanada: region === "CA",
    };
}

export default connect(mapStateToProps)(AreaInputs);
